export default __webpack_public_path__ + "static/media/search.54360497.svg";